import defaultTheme from "./defaultTheme";
import mainMenuTheme from "./mainMenuTheme";
import loadingTheme from "./loadingTheme";

export default {
  defaultTheme,
  mainMenuTheme,
  loadingTheme,
};
